import React from "react";
import { Link } from "@mui/material";

export default function PTMLink(props) {
    const {
        onClick, sx, children, href, target, color,
    } = props;
    return (
        // eslint-disable-next-line jsx-a11y/anchor-is-valid
        <Link
            sx={sx}
            onClick={onClick}
            style={{ cursor: "pointer" }}
            href={href}
            target={target}
        >
            <span style={{ color, textDecoration: "underline", textDecorationColor: color }}>{children}</span>
        </Link>
    );
}
